interface PhotoToSave {
  url: string;
  filename: string;
}

/**
 * Saves one or more photos to the device. Prefers the native share sheet
 * (iOS/Android offer "Save to Photos"/"Save image" there); falls back to
 * plain browser downloads (Files/Downloads app) when sharing files isn't
 * supported, or if the share attempt itself fails for a reason other than
 * the user cancelling it.
 */
export async function savePhotos(items: PhotoToSave[]): Promise<void> {
  if (items.length === 0) return;

  if (typeof navigator.share === "function" && typeof navigator.canShare === "function") {
    try {
      const files = await Promise.all(
        items.map(async ({ url, filename }) => {
          const blob = await (await fetch(url)).blob();
          return new File([blob], filename, { type: blob.type });
        }),
      );
      if (navigator.canShare({ files })) {
        await navigator.share({ files });
        return;
      }
    } catch (err) {
      if (err instanceof Error && err.name === "AbortError") return; // user closed the share sheet
      // otherwise fall through to plain downloads below
    }
  }

  for (const { url, filename } of items) {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    if (items.length > 1) await new Promise((resolve) => setTimeout(resolve, 150));
  }
}
